module.exports = __webpack_public_path__ + "img/365a5fc.png";